module.exports = __webpack_public_path__ + "img/demonstration-text-item-line5.6bd646f6.png";